/**
 * Membership FAQ – GLD-38
 * Enhances native <details> accordion with proper ARIA attributes and keyboard support.
 */

(function() {
  'use strict';

  function initFAQAccordion(section) {
    if (!section) return;

    const detailsElements = section.querySelectorAll('.membership-faq__details');
    
    detailsElements.forEach((details) => {
      const summary = details.querySelector('.membership-faq__summary');
      if (!summary) return;

      // Set initial aria-expanded state
      const isOpen = details.hasAttribute('open');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // Handle toggle events
      details.addEventListener('toggle', function() {
        const isNowOpen = details.hasAttribute('open');
        summary.setAttribute('aria-expanded', isNowOpen ? 'true' : 'false');
      });

      // Ensure keyboard accessibility
      summary.addEventListener('keydown', function(e) {
        // Allow Enter and Space to toggle
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          details.toggleAttribute('open');
        }
        // Escape closes the accordion
        if (e.key === 'Escape' && details.hasAttribute('open')) {
          e.preventDefault();
          details.removeAttribute('open');
          summary.focus();
        }
      });
    });
  }

  // Initialize on page load
  function initAllFAQAccordions() {
    const sections = document.querySelectorAll('.membership-faq');
    sections.forEach((section) => {
      initFAQAccordion(section);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFAQAccordions);
  } else {
    initAllFAQAccordions();
  }

  // Re-initialize when Shopify section editor loads/unloads sections
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = document.getElementById('section--' + event.detail.sectionId);
      if (section && section.classList.contains('membership-faq')) {
        initFAQAccordion(section);
      }
    });
  }
})();

